export const EBSCO_URLS = {
  PRIVACY_POLICY: "https://www.ebsco.com/company/privacy-policy/",
  TERMS_OF_USE: "https://www.ebsco.com/terms-of-use/",
  HELP_URL: "https://help.ebsco.com",
  MERGE_HELP_URL:
    "https://connect.ebsco.com/s/article/How-to-Merge-PUA-Accounts",
  DISCLAIMER: "https://www.ebsco.com/company/legal-disclaimer",
  SUPPORT_SITE: "https://connect.ebsco.com/s/",
  IOS_APP: "https://apps.apple.com/us/app/ebsco-mobile/id1473281170",
  ANDROID_APP:
    "https://play.google.com/store/apps/details?id=com.ebsco.ebscomobile"
};

export const NON_EBSCO_URLS = {
  ONE_TRUST_URL:
    "https://privacyportal-cdn.onetrust.com/dsarwebform/3dc851a7-8ce1-41dc-8d75-358b1fe8c84d/cd99c5d8-e12d-40bd-829b-e59b5ec502c9.html"
};

export const BREAKPOINTS = {
  CONTAINER: {
    MINIMUM_SCREEN_SIZE: 274,
    PHONE: 382,
    TABLET_SM: 738,
    TABLET_LG: 960,
    DESKTOP_SM: 1180,
    DESKTOP_MD: 1428,
    DESKTOP_LG: 1600
  },
  SCREEN: {
    MINIMUM_SCREEN_SIZE: 0,
    PHONE: 411,
    TABLET_SM: 767,
    TABLET_LG: 1023,
    DESKTOP_SM: 1239,
    DESKTOP_MD: 1499,
    DESKTOP_LG: 1919
  }
};

export const MY_ACCOUNT_SECTION_ID = "my-account";
export const AFFILIATIONS_SECTION_ID = "affiliations";
export const MERGE_ACCOUNTS_SECTION_ID = "merge-accounts";

export const AFFILIATION_STATUS = {
  VALID: "VALID",
  EXPIRED: "EXPIRED",
  REAUTHORIZE: "REAUTHORIZE"
};

export const VALIDATION_ERROR = "VALIDATION_ERROR";
export const VALIDATION_ERROR_ISSUES = {
  WRONG_ANSWER: "WRONG_ANSWER",
  EMAIL_UNAVAILABLE: "EMAIL_UNAVAILABLE",
  USERNAME_UNAVAILABLE: "USERNAME_UNAVAILABLE",
  BLACKLISTED_WORD: "BLACKLISTED_WORD",
  INVALID_CODE: "INVALID_CODE"
};

export const AUTHORIZATION_HEADER = "Authorization";

export const X_EIS_SOURCE_ACCESS_COOKIE = "X_EIS_SOURCE_ACCESS";
export const X_EIS_SOURCE_ID_COOKIE = "X_EIS_SOURCE_ID";

export const REQUEST_ORIGINATION_HEADER = {
  HEADER_NAME: "x-eis-origination-edge",
  HEADER_VALUE: "personaluser-ui"
};

export const ROUTES = {
  PASSWORD_UPDATE: "/user/password",
  DATA_RETENTION: "/user/data-retention",
  ACCOUNT_UPDATE: "/user",
  ACCOUNT_CREATE: "/user/create",
  PASSWORD_RESET: "/user/reset-password",
  MERGE_ACCOUNTS: "/user/merge-accounts",
  SECRET_QUESTION: "/user/secret-question"
};

export const PUA_UPDATE_PATH = `${ROUTES.ACCOUNT_UPDATE}?auth_type=personal`;

/**

Mapping keys for account metadata transformation.
Used to convert between API format and UI message keys during merge operations.
During the classic→new UI transition, the API may return both formats.
These constants ensure consistent mapping prioritizing new UI format.
API Format (kebab-case): UI Format (camelCase):
"alerts-journal" → "journalAlerts"
"alerts-search" → "searchAlerts"
*/
export const MAPPING_KEYS = {
  ALERTS_JOURNAL_KEY: "alerts-journal",
  ALERTS_SEARCH_KEY: "alerts-search",
  JOURNAL_ALERTS_KEY: "journalAlerts",
  SEARCH_ALERTS_KEY: "searchAlerts"
};
